export const invoiceSearchables = [
  'company',
  'customer number',
  'external invoice number',
  'ocr',
  'order reference id',
  'order additional reference',
  'id',
  'invoice customer email',
  'invoice customer reg number',
  'our reference',
  'your reference',
];

export const CreditStatus = Object.freeze({
  APPROVED: 'APPROVED',
  REJECTED: 'REJECTED',
  CONTROL: 'CONTROL',
});

export const CreditReasonType = Object.freeze({
  ENFORCEMENT_AGENCY: 'PETITIONS_AT_ENFORCEMENT_AGENCY_EXCEEDS_X',
  PAYMENT_REMARKS: 'PAYMENT_REMARKS_EXCEEDS_X',
  BANKRUPTCY: 'BANKRUPTCY',
});

export const SessionActionStatus = Object.freeze({
  COMPLETED: 'COMPLETED',
  PENDING: 'PENDING',
  FAILED: 'FAILED',
  MANUAL_CONTROL: 'MANUAL_CONTROL',
  ERROR: 'ERROR',
});

export const SessionActionType = Object.freeze({
  BANK_ID_VERIFICATION: 'BANK_ID_VERIFICATION',
  CREDIT_CHECK: 'CREDIT_CHECK',
  COMPLIANCE_VERIFICATION: 'COMPLIANCE_VERIFICATION',
  APPROVER_VERIFICATION: 'APPROVER_VERIFICATION',
  APPROVER_SIGN: 'APPROVER_SIGN',
  EMAIL_VERIFICATION: 'EMAIL_VERIFICATION',
});

export const SessionStatus = Object.freeze({
  ...SessionActionStatus,
  CREATED: 'CREATED',
  STARTED: 'STARTED',
});

export const CustomerTab = Object.freeze({
  SUMMARY: 'SUMMARY',
  PEOPLE: 'PEOPLE',
  CREDIT: 'CREDIT',
});
